<template>
  <label
    class="checkbox-container relative block cursor-pointer select-none pl-8"
    :class="{ '!cursor-not-allowed': disabled }"
  >
    <span
      class="mb-0.5"
      :class="{ 'text-[#939393]': disabled }"
    >
      <slot />
    </span>

    <input
      type="checkbox"
      class="peer absolute left-0 z-0 translate-y-0.5 cursor-pointer opacity-0"
      :checked="modelValue"
      :disabled="disabled"
      :name="name"
      @input="emit('update:modelValue', $event.target)"
    />

    <span
      class="
        checkbox-checkmark absolute inset-x-0 top-0 mt-1 block size-[1.25em]
        shrink-0 translate-y-[-0.1em] rounded-sm border-[0.125rem] border-black
        duration-100 ease-in-out
        peer-focus-visible:ring-2 peer-focus-visible:ring-offset-2
      "
    />
  </label>
</template>

<!-- eslint-disable-next-line vue/block-lang -->
<script setup>
const emit = defineEmits(['update:modelValue'])
defineProps({
  modelValue: {
    type: [Boolean, String],
    default: false,
  },

  name: {
    type: String,
    default: null,
  },

  disabled: {
    type: Boolean,
    default: false,
  },
})
</script>
